import AImage from './AImage.js';

export default class Abutton extends AImage
{
    constructor(scene, x, y, texture, upFrame, onClick)
    {
        super(scene, x, y, texture, upFrame);

        this.setInteractive({ useHandCursor: true  });
        this.upFrame = upFrame;
        this.onClick = onClick;
        this.btnTexture = texture;
        this.isDown = false;
        this.downTime = 0;
        this.originalTint = 0xffffff;

        this.on('pointerdown', (p) => { this.eh_PointerDown(p); });
        this.on('pointerup', (p) => { this.eh_PointerUp(p); });
        this.on('pointerout', (p) => { this.eh_PointerUp(p); });

        this.soundKey = "click";
        // this.scene.input.on('pointerup', ()=>{this.eh_PointerUp();});
    }

    preUpdate(){}

    set tint(value)
    {
        this.originalTint = value;
        super.tint = value;
    }

    eh_PointerDown(pointer)
    {
        if(!this.input.enabled) return;
        
        this.isDown = true;
        this.downTime = this.scene.time.now;

        this.depressButton();
        this.onPointerDown();
    }

    eh_PointerOut()
    {
        if(!this.input.enabled) return;

        if(this.isDown) this.unpressButton();
        this.isDown = false;
        this.onPointerOut();
    }

    eh_PointerUp(p)
    {
        if(!this.input.enabled || !this.isDown) return;

        this.unpressButton();

        if(this.isDown)
        {
            this.isDown = false;
            let timeDown = this.scene.time.now - this.downTime;
            let distanceTraveled = Phaser.Math.Distance.Between(p.downX, p.downY, p.upX, p.upY);
            if(this.onClick!= null && timeDown < 250 && distanceTraveled < 50)
            {
                this.onClick();
                this.scene.playSound(this.soundKey);
            }
        }
        this.onPointerUp();
    }

    setEnabled(enabled)
    {
        this.input.enabled = enabled;
        if(!enabled)
        {   
            this.disableInteractive();
            this.tint = 0xaaaaaa;
        }
        else
        {
            this.setInteractive();
            this.tint = 0xffffff;
        }
    }

    changeFrame(upFrame, downFrame = null)
    {
        this.upFrame = upFrame;
        this.config.frameOnDown = downFrame;
        this.setFrame(this.upFrame, false, false);
    }

    onPointerDown(){} //OVERRIDE THESE GUYS
    onPointerUp(){}
    onPointerOut(){}

    depressButton()
    {
        this.scene.killTween(this);
        this.scene.addTween(this, 100, {scaleX: .9, scaleY: .9}, Phaser.Math.Easing.Sine.Out);
    }
    
    unpressButton()
    {
        this.scene.killTween(this);
        this.scene.addTween(this, 1000, {scaleX: 1, scaleY: 1}, "Elastic");
    }
}